module.exports = __webpack_public_path__ + "fonts/baronsans-lightitalic-webfont.09e03415.woff2";